import { baseApi } from '../axios';

export const getRequestCallbacks = async ({ source }: { source?: string }) => {
	const url = `/request-callback${source ? `?source=${source}` : ''}`;
	const response = await baseApi.get(url);
	return response;
};

export const createRequestCallback = async ({ date, query, source }: { date: string; query: string; source: string }) => {
	const response = await baseApi.post(`/request-callback`, { date, query, source });
	return response;
};
